export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-folder-lock-3559a3ebc32d6c1adc486827ae49bb53.svg";